import React, { Component } from "react";
import "../../Controls/ListingPage.css";
import Input from "../../Controls/Input";
import TemplateFormModal from "./TemplateFormModal";
import { allTransactionalVariables, predefinedTransactionalTemplates } from "./integartionHelper";

class TransactionalTemplates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowedTransactionTypes: [],
            isUpdatingProvider: false,
            showFormModal: false,
            templateToEdit: null,
            selectedTransactionalCategory: "All",
            selectedTransactionalTemplate: null,
            templates: [],
            searchQuery: "",
            loading: true,
            error: null,
            loadingSubmit: false,
            loadingDelete: false
        };
    }

    // Function to fetch templates from backend
    fetchTemplates = async () => {
        const { providerId, isPosible, registrationId } = this.props;

        this.setState({ loading: true, error: null });
        try {
            const data = await this.props.getTemplates(providerId, "Transactional", registrationId);
            if (data.code !== "0") {
                return this.props.getToastr("Unable to fetch Transactional Templates");
            }
            let backendTemplates = data.data || data.templates || [];

            if (isPosible) {
                const mappedPosibleTemplates = backendTemplates.map(bt => ({
                    _id: bt._id,
                    templateId: bt.templateId,
                    name: bt.templateName,
                    eventName: bt.eventName,
                    category: (predefinedTransactionalTemplates.find(p => p.eventName === bt.eventName) || {}).category || "General",
                    content: bt.content,
                    variables: bt.variables,
                    isActive: bt.isActive !== false,
                    isSetupDone: bt.isActive !== false,
                    lastUpdated: bt.updatedAt
                }));

                this.setState({
                    templates: mappedPosibleTemplates,
                    selectedTransactionalTemplate: null
                });
            } else {
                const mergedTemplates = predefinedTransactionalTemplates.map(
                    (predefined) => {
                        const backendMatch = backendTemplates.find(
                            (bt) => bt.eventName === predefined.eventName
                        );
                        return backendMatch
                            ? {
                                ...predefined,
                                _id: backendMatch._id,
                                name: backendMatch.templateName,
                                templateId: backendMatch.templateId,
                                content: backendMatch.content,
                                variables: backendMatch.variables,
                                variableMappings: backendMatch.variableMappings || {},
                                manualVariables: backendMatch.manualVariables || [],
                                isSetupDone: true,
                                lastUpdated: backendMatch.updatedAt,
                            }
                            : {
                                ...predefined,
                                content: predefined.defaultContent,
                                isSetupDone: false,
                                lastUpdated: null,
                                variableMappings: {},
                                manualVariables: []
                            };
                    }
                );
                this.setState({
                    templates: mergedTemplates,
                    selectedTransactionalTemplate: null
                });
            }
        } catch (err) {
            console.error("Error fetching transactional templates:", err);
            this.setState({ error: "Failed to load templates. Please try again." });
            if (!this.props.isPosible) {
                this.setState({
                    templates: predefinedTransactionalTemplates.map((template) => ({
                        ...template,
                        content: template.defaultContent,
                        isSetupDone: false,
                        lastUpdated: null,
                    }))
                });
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    // Fetch provider details to get allowed transaction types
    fetchProviderDetails = async () => {
        const { registrationId, providerId } = this.props;
        if (!registrationId) return;
        try {
            const data = await this.props.getWhatsappAllProviders(registrationId);
            if (data.code === "0") {
                const currentProvider = data.data.find(p => p.id === providerId || p._id === providerId);
                if (currentProvider) {
                    this.setState({ allowedTransactionTypes: currentProvider.salesInvoiceAllowedTransactionTypes || [] });
                }
            }
        } catch (err) {
            console.error("Error fetching provider details:", err);
        }
    };

    componentDidMount() {
        const { providerId } = this.props;
        console.log("provider id",providerId);
        if (providerId) {
            this.fetchTemplates();
            this.fetchProviderDetails();
        }
    }

    componentDidUpdate(prevProps) {
        const { providerId } = this.props;
        if (prevProps.providerId !== providerId && providerId) {
            this.fetchTemplates();
            this.fetchProviderDetails();
        }
    }

    handleTransactionTypeChange = (typeKey, isChecked) => {
        this.setState(prevState => {
            const newAllowedTypes = isChecked
                ? [...prevState.allowedTransactionTypes, typeKey]
                : prevState.allowedTransactionTypes.filter(t => t !== typeKey);
            return { allowedTransactionTypes: newAllowedTypes };
        });
    };

    saveAllowedTransactionTypes = async () => {
        const { providerId } = this.props;
        const { allowedTransactionTypes } = this.state;

        try {
            this.setState({ isUpdatingProvider: true });
            const payload = {
                salesInvoiceAllowedTransactionTypes: allowedTransactionTypes
            };
            const response = await this.props.updateProvider(providerId, payload);
            if (response.code === "0") {
                this.props.getToastr("Allowed transaction types updated successfully");
            } else {
                this.props.getToastr("Failed to update allowed transaction types");
            }
        } catch (err) {
            console.error("Error updating provider:", err);
        this.props.getToastr("An error occurred while saving");
        } finally {
            this.setState({ isUpdatingProvider: false });
        }
    };

    handleModalSubmit = async (formData) => {
        const { registrationId, providerId } = this.props;

        try {
            this.setState({ loadingSubmit: true });
            const payload = {
                registrationId: registrationId,
                templateId: formData.templateId,
                templateName: formData.name,
                eventName: formData.eventName,
                providerId: providerId,
                contentType: "Transactional",
                content: formData.content,
                variables: formData.variables,
                variableMappings: formData.variableMappings,
                manualVariables: formData.manualVariables,
                id: formData._id,
            };

            console.log(payload, "payload modal");

            let response;
            if (!formData._id) {
                response = await this.props.createTemplate(payload);
            } else {
                response = await this.props.updateTemplate(payload);
            }

            if (response.code == "0") {
                this.props.getToastr("template successfully configured");
            } else {
                return this.props.getToastr("unable to configured template");
            }

            await this.fetchTemplates();

            this.setState(prevState => ({
                selectedTransactionalTemplate: prevState.selectedTransactionalTemplate && prevState.selectedTransactionalTemplate.id === formData.id
                    ? {
                        ...prevState.selectedTransactionalTemplate,
                        name: formData.name,
                        content: formData.content,
                        variableMappings: formData.variableMappings,
                        manualVariables: formData.manualVariables,
                        isSetupDone: true,
                        lastUpdated: response.data.updatedAt,
                    }
                    : prevState.selectedTransactionalTemplate,
                showFormModal: false
            }));

            console.log(`Transactional template "${formData.name}" updated successfully!`);
        } catch (err) {
            console.error("Error updating transactional template:", err);
            alert("Failed to update template. Please try again.");
        } finally {
            this.setState({ loadingSubmit: false });
        }
    };

    handleToggleTemplateStatus = async (template) => {
        const { isPosible, registrationId, providerId } = this.props;

        try {
            this.setState({ loadingSubmit: true });

            if (isPosible) {
                const newStatus = !template.isSetupDone;
                const payload = {
                    templateId: template._id,
                    registrationId: registrationId,
                    status: newStatus,
                    providerId: providerId
                };

                const response = await this.props.togglePosibleTemplateStatus(payload);

                if (response.code === "0") {
                    this.props.getToastr(newStatus ? "Template activated successfully" : "Template deactivated successfully");
                    await this.fetchTemplates();
                } else {
                    this.props.getToastr("Failed to update status");
                }
            } else {
                if (template._id) {
                    const newStatus = !template.isSetupDone;
                    const payload = {
                        ...template,
                        registrationId: registrationId,
                        templateId: template.templateId,
                        templateName: template.name,
                        eventName: template.eventName,
                        providerId: providerId,
                        contentType: "Transactional",
                        content: template.content,
                        variables: template.variables,
                        id: template._id,
                        isActive: newStatus
                    };

                    const response = await this.props.updateTemplate(payload);
                    if (response.code === "0") {
                        this.props.getToastr(newStatus ? "Template activated successfully" : "Template deactivated successfully");
                        await this.fetchTemplates();
                    } else {
                        this.props.getToastr("Failed to update template status");
                    }
                } else {
                    const payload = {
                        registrationId: registrationId,
                        templateId: template.templateId,
                        templateName: template.name,
                        eventName: template.eventName,
                        providerId: providerId,
                        contentType: "Transactional",
                        content: template.defaultContent || template.content,
                        variables: template.variables,
                        isActive: true
                    };

                    const response = await this.props.createTemplate(payload);
                    if (response.code === "0") {
                        this.props.getToastr("Template activated successfully");
                        await this.fetchTemplates();
                    } else {
                        this.props.getToastr("Failed to activate template");
                    }
                }
            }
        } catch (err) {
            console.error("Error toggling template status:", err);
            this.props.getToastr("An error occurred");
        } finally {
            this.setState({ loadingSubmit: false });
        }
    };

    handleDeleteTemplate = async (template) => {
        if (!window.confirm("Are you sure you want to delete this template? This action cannot be undone.")) {
            return;
        }

        try {
            this.setState({ loadingSubmit: true });
            const idToDelete = template._id || template.id;

            if (!idToDelete) {
                this.props.getToastr("Invalid template ID");
                return;
            }

            const response = await this.props.deleteTemplate(idToDelete);

            if (response.code === "0" || (response.message && response.message.includes("deleted successfully"))) {
                this.props.getToastr("Template deleted successfully");
                await this.fetchTemplates();
            } else {
                this.props.getToastr(response.message || "Failed to delete template");
            }
        } catch (err) {
            console.error("Error deleting template:", err);
            this.props.getToastr("An error occurred while deleting");
        } finally {
            this.setState({ loadingSubmit: false });
        }
    };

    handleSetupEditTransactional = (template) => {
        console.log("template",template);
        this.setState({
            templateToEdit: {
                ...template,
                _id: template._id,
                templateId: template.templateId,
                name: template.name,
                category: template.category,
                content: template.content,
                 eventName: template.eventName,
                variables: template.variables,
                variableMappings: template.variableMappings,
                manualVariables: template.manualVariables
            },
            showFormModal: true
        });
    };

    getTransactionalCategories = () => {
        const { isPosible, templates } = this.state;

        if (isPosible) {
            const categories = [...new Set(templates.map(t => t.category))];
            return ["All", ...categories.sort()];
        }
        const categories = [
            ...new Set(predefinedTransactionalTemplates.map((t) => t.category)),
        ];
        return ["All", ...categories.sort()];
    };

    getFilteredTemplates = () => {
        const { templates, selectedTransactionalCategory, searchQuery } = this.state;

        const filteredByCategory = selectedTransactionalCategory === "All"
            ? templates
            : templates.filter((t) => t.category === selectedTransactionalCategory);

        return searchQuery
            ? filteredByCategory.filter(
                (t) =>
                    t.eventName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    t.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    (t.content && t.content.toLowerCase().includes(searchQuery.toLowerCase()))
            )
            : filteredByCategory;
    };

    componentDidUpdate(prevProps, prevState) {
        const filteredTemplates = this.getFilteredTemplates();
        const { selectedTransactionalTemplate } = this.state;

        if (filteredTemplates.length > 0 && prevState.selectedTransactionalCategory !== this.state.selectedTransactionalCategory) {
            const currentId = selectedTransactionalTemplate && (selectedTransactionalTemplate.templateId || selectedTransactionalTemplate._id);
            const isSelectedInList = currentId && filteredTemplates.some(t => (t.templateId || t._id) === currentId);

            if (!isSelectedInList) {
                this.setState({ selectedTransactionalTemplate: filteredTemplates[0] });
            }
        } else if (filteredTemplates.length === 0 && selectedTransactionalTemplate) {
            this.setState({ selectedTransactionalTemplate: null });
        }
    }

    renderContentPreview = () => {
        const { selectedTransactionalTemplate } = this.state;
        if (!selectedTransactionalTemplate) return null;

        let content = selectedTransactionalTemplate.content;
        if (selectedTransactionalTemplate.variables && selectedTransactionalTemplate.variableMappings) {
            selectedTransactionalTemplate.variables.forEach(varNum => {
                const mapping = selectedTransactionalTemplate.variableMappings[varNum];
                let displayVal = `{{${varNum}}}`;

                if (mapping) {
                    if (mapping.type === 'static' && mapping.value) {
                        displayVal = mapping.value;
                    } else if (mapping.type === 'dynamic' && mapping.value) {
                        const varObj = allTransactionalVariables.find(v => v.value === mapping.value);
                        displayVal = varObj ? `[${varObj.label}]` : `[${mapping.value}]`;
                    }
                }
                content = content.split(`{{${varNum}}}`).join(displayVal);
            });
        }
        return content;
    };

    render() {
        const { providerName, registrationId, isPosible } = this.props;
        const {
            allowedTransactionTypes,
            isUpdatingProvider,
            showFormModal,
            templateToEdit,
            selectedTransactionalCategory,
            selectedTransactionalTemplate,
            searchQuery,
            loading,
            error,
            loadingSubmit,
            loadingDelete,
            templates
        } = this.state;

        let salesTransactionType = [];

        this.props.config.TransactionTypes
            .filter((e) => e.Module === "sales" && !e.IsDeleted)
            .map((e) => {
                    salesTransactionType.push(e);
                
            });
        const filteredTemplates = this.getFilteredTemplates();

        // Inline styles
        const containerStyle = {
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(4px)",
            borderRadius: "24px"
        };

    const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "500px 1fr",
    gap: "24px",
    height: "calc(100vh - 190px)", // ✅ full height
    overflow: "hidden" // ✅ prevents parent scroll
};
const leftColumnStyle = {
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
    height: "100%",          // ✅ full height
    overflowY: "auto",       // ✅ independent scroll
};

        const categoryHeaderStyle = {
            fontSize: "20px",
            fontWeight: "600",
            color: "#1e293b",
            marginBottom: "8px"
        };

        const selectStyle = {
            width: "100%",
            padding: "8px 16px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "16px",
            cursor: "pointer",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
        };

        const listStyle = {
            marginTop: "16px",
            listStyle: "none",
            padding: 0
        };

        const listItemStyle = {
            marginBottom: "8px"
        };

    const rightColumnStyle = {
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)",
    height: "100%",
    display: "flex",
    flexDirection: "column", // ✅ important
    overflow: "hidden"       // ✅ prevent outer scroll
};

    const contentAreaStyle = {
    flex: 1,              // ✅ takes remaining space
    overflowY: "auto",    // ✅ scroll only content
    padding: "24px"
};

        const sectionBorderStyle = {
            borderBottom: "1px solid #e2e8f0",
            paddingBottom: "12px",
            marginBottom: "16px"
        };

        const eventNameSmallStyle = {
            fontSize: "14px",
            fontWeight: "500",
            color: "#64748b"
        };

        const templateTitleRowStyle = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "4px"
        };

        const templateTitleStyle = {
            fontSize: "20px",
            fontWeight: "600",
            color: "#1e293b"
        };

        const categoryBadgeStyle = {
            padding: "4px 12px",
            borderRadius: "9999px",
            fontSize: "14px",
            fontWeight: "500",
            backgroundColor: "#e2e8f0",
            color: "#334155"
        };

        const previewGridStyle = {
            display: "grid",
            gap: "24px",
            marginBottom: "16px",
            gridTemplateColumns: selectedTransactionalTemplate && selectedTransactionalTemplate.eventName === "sales" ? "repeat(1, minmax(0, 1fr))" : "repeat(1, minmax(0, 1fr))"
        };

        const previewCardStyle = {
            backgroundColor: "#ffffff",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            padding: "16px",
            marginTop: "8px"
        };

        const transactionTypeCardStyle = {
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            padding: "16px",
            backgroundColor: "#f8fafc",
            marginTop: "auto",
            marginBottom: 0
        };

        const transactionTypeHeaderStyle = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px"
        };

        const saveButtonStyle = {
            padding: "4px 12px",
            fontSize: "12px",
            fontWeight: "600",
            backgroundColor: "#2563eb",
            color: "#ffffff",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer"
        };

        const saveButtonDisabledStyle = {
            opacity: 0.5,
            cursor: "not-allowed"
        };

        const transactionTypeGridStyle = {
            display: "grid",
            gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
            gap: "8px",
            maxHeight: "160px",
            overflowY: "auto",
            backgroundColor: "#ffffff",
            padding: "12px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0"
        };

        const checkboxLabelStyle = {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer"
        };

        const variablesSectionStyle = {
            marginBottom: "16px"
        };

        const variablesHeaderStyle = {
            fontWeight: "500",
            color: "#475569",
            marginTop: "40px"
        };

        const variableListStyle = {
            display: "flex",
            flexDirection: "column",
            gap: "8px"
        };

        const variableItemStyle = {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px"
        };

        const variableBadgeStyle = {
            padding: "4px 8px",
            backgroundColor: "#dbeafe",
            color: "#1e40af",
            borderRadius: "6px",
            fontFamily: "monospace"
        };

        const sampleDataStyle = {
            marginBottom: "16px",
            color: "#475569",
            backgroundColor: "#f8fafc",
            padding: "16px",
            borderRadius: "8px",
            border: "1px dashed #cbd5e1"
        };

        const sampleContentStyle = {
            backgroundColor: "#ffffff",
            border: "1px solid #e2e8f0",
            borderRadius: "4px",
            padding: "12px",
            marginBottom: "8px"
        };

        const copyButtonStyle = {
            fontSize: "14px",
            fontWeight: "600",
            color: "#2563eb",
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "4px"
        };

        const statusSectionStyle = {
            marginBottom: "24px",
            fontSize: "14px",
            color: "#475569"
        };

        const statusTextStyle = {
            fontWeight: "bold"
        };

        const statusActiveStyle = {
            color: "#059669"
        };

        const statusInactiveStyle = {
            color: "#dc2626"
        };

   const buttonContainerStyle = {
    padding: "16px",
    backgroundColor: "#ffffff",
    borderTop: "1px solid #e2e8f0",
    position: "sticky",   // ✅ key
    bottom: 0,            // ✅ stick to bottom
    zIndex: 10
};

        const buttonGroupStyle = {
            display: "flex",
            gap: "12px"
        };

        const activateButtonStyle = {
            flex: 1,
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            border: "none",
            cursor: "pointer",
            backgroundColor: "#059669",
            color: "#ffffff"
        };

        const deactivateButtonStyle = {
            flex: 1,
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            border: "1px solid #fecaca",
            cursor: "pointer",
            backgroundColor: "#fef2f2",
            color: "#dc2626"
        };

        const editButtonStyle = {
            flex: 1,
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            border: "none",
            cursor: "pointer",
            backgroundColor: "#e2e8f0",
            color: "#334155"
        };

        const deleteButtonStyle = {
            flex: 1,
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            border: "1px solid #fecaca",
            cursor: "pointer",
            backgroundColor: "#fef2f2",
            color: "#dc2626"
        };

        const setupButtonStyle = {
            flex: 1,
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            border: "none",
            cursor: "pointer",
            backgroundColor: "#2563eb",
            color: "#ffffff"
        };

        const copyIconButtonStyle = {
            padding: "12px 16px",
            borderRadius: "12px",
            fontWeight: "600",
            border: "none",
            cursor: "pointer",
            backgroundColor: "#f1f5f9",
            color: "#334155"
        };

        const loadingStyle = {
            textAlign: "center",
            padding: "40px",
            color: "#64748b"
        };

        const errorStyle = {
            textAlign: "center",
            padding: "40px",
            color: "#ef4444"
        };

        const emptyStateStyle = {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            padding: "24px",
            color: "#64748b"
        };

        const emptyStateTextStyle = {
            fontSize: "18px"
        };

        if (loading) {
            return (
                <div style={loadingStyle}>
                    Loading templates...
                </div>
            );
        }

        if (error) {
            return <div style={errorStyle}>Error: {error}</div>;
        }

        return (
            <>
                <div style={containerStyle}>
                    <div style={gridContainerStyle}>
                        {/* Left Column: Template List and Filter */}
                        <div style={leftColumnStyle}>
                            <div style={{ marginBottom: "16px" }}>
                                <h3 style={categoryHeaderStyle}>
                                    Template Categories
                                </h3>
                                <select
                                    style={selectStyle}
                                    value={selectedTransactionalCategory}
                                    onChange={(e) => {
                                        this.setState({
                                            selectedTransactionalCategory: e.target.value,
                                            selectedTransactionalTemplate: null
                                        });
                                    }}
                                >
                                    {this.getTransactionalCategories().map((cat) => (
                                        <option key={cat} value={cat}>
                                            {cat}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <ul style={listStyle}>
                                {filteredTemplates.length > 0 ? (
                                    filteredTemplates.map((template) => (
                                        <li key={template.templateId || template._id} style={listItemStyle}>
                                            <button
                                                onClick={() => this.setState({ selectedTransactionalTemplate: template })}
                                                style={{
                                                    width: "100%",
                                                    textAlign: "left",
                                                    padding: "16px 12px",
                                                    borderRadius: "8px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    transition: "all 200ms",
                                                    cursor: "pointer",
                                                    border: "none",
                                                    background: "transparent",
                                                    ...(selectedTransactionalTemplate && (selectedTransactionalTemplate.templateId === template.templateId)
                                                        ? {
                                                            backgroundColor: "rgba(59, 130, 246, 0.1)",
                                                            color: "#1e3a8a",
                                                            fontWeight: "600",
                                                            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
                                                        }
                                                        : {
                                                            backgroundColor: "#ffffff",
                                                            color: "#334155"
                                                        })
                                                }}
                                            >
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <span style={{ fontWeight: "500", fontSize: "14px", color: "#64748b" }}>
                                                        {template.eventName}
                                                    </span>
                                                    <span
                                                        style={{
                                                            padding: "2px 8px",
                                                            borderRadius: "9999px",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            ...(template.isSetupDone
                                                                ? {
                                                                    backgroundColor: "#d1fae5",
                                                                    color: "#047857"
                                                                }
                                                                : {
                                                                    backgroundColor: "#fee2e2",
                                                                    color: "#b91c1c"
                                                                })
                                                        }}
                                                    >
                                                        {template.isSetupDone ? "Active" : "Pending"}
                                                    </span>
                                                </div>
                                                <span style={{ fontSize: "16px", marginTop: "4px" }}>{template.name}</span>
                                            </button>
                                        </li>
                                    ))
                                ) : (
                                    <li style={{ color: "#64748b", textAlign: "center", padding: "16px" }}>
                                        No templates found.
                                    </li>
                                )}
                            </ul>
                        </div>

                        {/* Right Column: Selected Template Details */}
                        <div style={rightColumnStyle}>
                            {selectedTransactionalTemplate ? (
                                <>
                                    <div style={contentAreaStyle}>
                                        <div style={sectionBorderStyle}>
                                            <h3 style={eventNameSmallStyle}>
                                                {selectedTransactionalTemplate.eventName}
                                            </h3>
                                            <div style={templateTitleRowStyle}>
                                                <h2 style={templateTitleStyle}>
                                                    {selectedTransactionalTemplate.name}
                                                </h2>
                                                <span style={categoryBadgeStyle}>
                                                    {selectedTransactionalTemplate.category}
                                                </span>
                                            </div>
                                        </div>

                                        <div style={{
                                            ...previewGridStyle,
                                            ...(selectedTransactionalTemplate.eventName === "sales" && window.innerWidth >= 1024 ? { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" } : {})
                                        }}>
                                            <div style={{ color: "#475569" }}>
                                                <p style={{ fontWeight: "500" }}>Content Preview:</p>
                                                <div style={previewCardStyle}>
                                                    <p style={{ whiteSpace: "pre-wrap" }}>
                                                        {this.renderContentPreview()}
                                                    </p>
                                                </div>
                                            </div>

                                            {selectedTransactionalTemplate.eventName === "sales" && salesTransactionType && (
                                                <div style={transactionTypeCardStyle}>
                                                    <div style={transactionTypeHeaderStyle}>
                                                        <p style={{ fontWeight: "500", color: "#1e293b" }}>
                                                            Allowed Transaction Types
                                                        </p>
                                                        <button
                                                            onClick={this.saveAllowedTransactionTypes}
                                                            disabled={isUpdatingProvider}
                                                            style={{
                                                                ...saveButtonStyle,
                                                                ...(isUpdatingProvider ? saveButtonDisabledStyle : {})
                                                            }}
                                                        >
                                                            {isUpdatingProvider ? "Saving..." : "Save Mapping"}
                                                        </button>
                                                    </div>
                                                    <p style={{ fontSize: "12px", color: "#64748b", marginBottom: "12px" }}>
                                                        Select for which transaction types this invoice template should be sent.
                                                    </p>
                                                    <div style={transactionTypeGridStyle}>
                                                        {salesTransactionType.map((type) => (
                                                            <label key={type.key} style={checkboxLabelStyle}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={allowedTransactionTypes.includes(type.key)}
                                                                    onChange={(e) => this.handleTransactionTypeChange(type.key, e.target.checked)}
                                                                    style={{
                                                                        borderRadius: "4px",
                                                                        borderColor: "#d1d5db"
                                                                    }}
                                                                />
                                                                <span style={{ fontSize: "14px", color: "#334155" }}>{type.TransactionType}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div style={variablesSectionStyle}>
                                            <p style={variablesHeaderStyle}>
                                                Available Variables:
                                            </p>
                                            <div style={variableListStyle}>
                                                {selectedTransactionalTemplate.variables && selectedTransactionalTemplate.variables.map((variable) => {
                                                    const mapping = selectedTransactionalTemplate.variableMappings ? selectedTransactionalTemplate.variableMappings[variable] : null;
                                                    let mappedInfo = "Unmapped";
                                                    if (mapping) {
                                                        if (mapping.type === 'static') {
                                                            mappedInfo = `Static: "${mapping.value}"`;
                                                        } else if (mapping.value) {
                                                            const varObj = allTransactionalVariables.find(v => v.value === mapping.value);
                                                            mappedInfo = varObj ? varObj.label : mapping.value;
                                                        }
                                                    }

                                                    return (
                                                        <div
                                                            key={variable}
                                                            style={variableItemStyle}
                                                        >
                                                            <span style={variableBadgeStyle}>
                                                                {`{{${variable}}}`}
                                                            </span>
                                                            <span style={{ color: "#64748b" }}>
                                                                → {mappedInfo}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        {!selectedTransactionalTemplate.isSetupDone && (
                                            <div style={sampleDataStyle}>
                                                <p style={{ fontWeight: "500", marginBottom: "4px" }}>Sample Data (for Service Provider Setup):</p>
                                                <p style={{ fontSize: "12px", color: "#64748b", marginBottom: "8px" }}>
                                                    Copy this content to paste into your WhatsApp Service Provider template form.
                                                </p>
                                                <div style={sampleContentStyle}>
                                                    <p style={{ whiteSpace: "pre-wrap", fontFamily: "monospace", fontSize: "14px", color: "#334155" }}>
                                                        {selectedTransactionalTemplate.content}
                                                    </p>
                                                </div>
                                                <button
                                                    onClick={() => {
                                                        const textarea = document.createElement("textarea");
                                                        textarea.value = selectedTransactionalTemplate.content;
                                                        document.body.appendChild(textarea);
                                                        textarea.select();
                                                        document.execCommand("copy");
                                                        document.body.removeChild(textarea);
                                                        this.props.getToastr("Sample content copied!");
                                                    }}
                                                    style={copyButtonStyle}
                                                >
                                                    📋 Copy Content
                                                </button>
                                            </div>
                                        )}

                                        <div style={statusSectionStyle}>
                                            <p style={{ fontWeight: "500", marginBottom: "4px" }}>
                                                Status:{" "}
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                        ...(selectedTransactionalTemplate.isSetupDone
                                                            ? { color: "#059669" }
                                                            : { color: "#dc2626" })
                                                    }}
                                                >
                                                    {selectedTransactionalTemplate.isSetupDone
                                                        ? "Active"
                                                        : "Not Configured"}
                                                </span>
                                            </p>
                                            {selectedTransactionalTemplate.lastUpdated && (
                                                <p>
                                                    Last Updated:{" "}
                                                    {new Date(
                                                        selectedTransactionalTemplate.lastUpdated
                                                    ).toLocaleString()}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div style={buttonContainerStyle}>
                                        <div style={buttonGroupStyle}>
                                            {isPosible ? (
                                                <button
                                                    onClick={() => this.handleToggleTemplateStatus(selectedTransactionalTemplate)}
                                                    style={selectedTransactionalTemplate.isSetupDone ? deactivateButtonStyle : activateButtonStyle}
                                                    disabled={loadingSubmit}
                                                >
                                                    {loadingSubmit ? "Processing..." : selectedTransactionalTemplate.isSetupDone ? "🚫 Deactivate" : "✅ Activate"}
                                                </button>
                                            ) : (
                                                selectedTransactionalTemplate.isSetupDone ? (
                                                    <>
                                                        <button
                                                            onClick={() => this.handleSetupEditTransactional(selectedTransactionalTemplate)}
                                                            style={editButtonStyle}
                                                            disabled={loadingSubmit}
                                                        >
                                                            ✏️ Edit
                                                        </button>
                                                        <button
                                                            onClick={() => this.handleDeleteTemplate(selectedTransactionalTemplate)}
                                                            style={deleteButtonStyle}
                                                            disabled={loadingDelete || loadingSubmit}
                                                        >
                                                            {loadingDelete ? "Deleting..." : "🗑️ Delete"}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        onClick={() =>
                                                            this.handleSetupEditTransactional(
                                                                selectedTransactionalTemplate
                                                            )
                                                        }
                                                        style={setupButtonStyle}
                                                    >
                                                        🚀 Setup Template
                                                    </button>
                                                )
                                            )}
                                            {selectedTransactionalTemplate.isSetupDone && (
                                                <button
                                                    onClick={() => {
                                                        const textarea = document.createElement("textarea");
                                                        textarea.value = selectedTransactionalTemplate.content;
                                                        document.body.appendChild(textarea);
                                                        textarea.select();
                                                        document.execCommand("copy");
                                                        document.body.removeChild(textarea);
                                                    this.props.getToastr("Copied to clipboard!");
                                                    }}
                                                    style={copyIconButtonStyle}
                                                >
                                                    📋 Copy
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div style={emptyStateStyle}>
                                    <p style={emptyStateTextStyle}>
                                        {searchQuery
                                            ? "No template selected. Try refining your search."
                                            : "Select a template from the left to view details."}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {!isPosible && (
                    <TemplateFormModal
                          {...this.props}
                        isOpen={showFormModal}
                        onClose={() => this.setState({ showFormModal: false })}
                        onSubmit={this.handleModalSubmit}
                        templateType="transactional"
                        loading={loadingSubmit}
                         initialData={templateToEdit} 
                    />
                )}
            </>
        );
    }
}

export default TransactionalTemplates;